import { Module } from "wrapper6";
import $ from 'jquery';

export default class openPositionFilter extends Module {

    
    ready() {
        /*
        * Country selection
        */
        this.LOCATION_SELECTOR = '#location';
        this.LANGUAGE_SELECTOR = '#language';
        this.APPLICATION_LINK = '#applicationlink';
        this.CARD_WRAPPER = '#cards';
        this.CONTENT_WRAPPER = '.so-widget-mtt-open-positions-base .left';

        $(document).on('change', this.LANGUAGE_SELECTOR, () => this.filter(main_theme_objects.ajax_url));
        $(document).on('change', this.LOCATION_SELECTOR, () => this.filter(main_theme_objects.ajax_url));
        $(this.APPLICATION_LINK).on('click', function (e) {
            e.preventDefault();
            if($('#gdprcheck').is(':checked')){
                window.location.href = $(this).attr('href');
                $('.checkup').css('color', '#16161B')
                $('#gdprwarn').html('');
            } else {
                $('#gdprwarn').html('Please accept GDPR and terms');
                $('.checkup').css('color', '#FD6C72');

                window.setTimeout(() => {
                    $('.checkup').css('color', '#16161B');
                    window.setTimeout(() => {
                        $('.checkup').css('color', '#FD6C72')
                        window.setTimeout(() => {
                            $('.checkup').css('color', '#16161B')
                        }, 350)
                    }, 350)
                }, 350)
            }
        })
    }

    startLoading() {
        $(this.CONTENT_WRAPPER).addClass('loading');
    }

    stopLoading() {
        $(this.CONTENT_WRAPPER).removeClass('loading');
    }

    filter(ajaxurl){
        let locSlug = $(this.LOCATION_SELECTOR).val();
        let langSlug = $(this.LANGUAGE_SELECTOR).val();

        let data = {
            'action': 'filter_positions',
            'locationSlug': locSlug,
            'languageSlug': langSlug,
        };

        this.startLoading();

        $.post(ajaxurl, data, response => {
            $('#cards').html(response.html);
        }).always(() => {
            this.stopLoading();
        });
    }
}